export function epzs(id, padding = 0) {
  var EPPZScrollTo = {
    documentVerticalScrollPosition: function () {
      if (self.pageYOffset) return self.pageYOffset; // Firefox, Chrome, Opera, Safari.
      if (document.documentElement && document.documentElement.scrollTop) return document.documentElement.scrollTop; // Internet Explorer 6 (standards mode).
      if (document.body.scrollTop) return document.body.scrollTop; // Internet Explorer 6, 7 and 8.
      return 0; // None of the above.
    },

    viewportHeight: function () {
      return document.compatMode === 'CSS1Compat' ? document.documentElement.clientHeight : document.body.clientHeight;
    },

    documentHeight: function () {
      return document.height !== undefined ? document.height : document.body.offsetHeight;
    },

    documentMaximumScrollPosition: function () {
      return this.documentHeight() - this.viewportHeight();
    },

    elementVerticalClientPositionById: function (id) {
      var element = document.getElementById(id);
      var rectangle = element.getBoundingClientRect();
      return rectangle.top;
    },

    scrollVerticalTickToPosition: function (currentPosition, targetPosition) {
      var filter = 0.15;
      var fps = 60;
      var difference = parseFloat(targetPosition) - parseFloat(currentPosition);

      var arrived = Math.abs(difference) <= 0.5;
      if (arrived) {
        scrollTo(0.0, targetPosition);
        return;
      }

      currentPosition = parseFloat(currentPosition) * (1.0 - filter) + parseFloat(targetPosition) * filter;

      scrollTo(0.0, Math.round(currentPosition));

      var that = this;

      setTimeout(function () {
        that.scrollVerticalTickToPosition(currentPosition, targetPosition);
      }, 1000 / fps);
    },

    scrollVerticalToElementById: function (id, padding) {
      var element = document.getElementById(id);
      if (element == null) {
        console.warn("Cannot find element with id '" + id + "'.");
        return;
      }

      var targetPosition = this.documentVerticalScrollPosition() + this.elementVerticalClientPositionById(id) - padding;
      var currentPosition = this.documentVerticalScrollPosition();

      var maximumScrollPosition = this.documentMaximumScrollPosition();
      if (targetPosition > maximumScrollPosition) targetPosition = maximumScrollPosition;

      this.scrollVerticalTickToPosition(currentPosition, targetPosition);
    },
  };

  EPPZScrollTo.scrollVerticalToElementById(id, padding);
}
export function doScrollingQuery(query, duration = 700) {
  var startingY = window.pageYOffset;

  var div = document.querySelector(query);

  var rect = div.getBoundingClientRect();

  var elementY = rect.top;

  // console.log(elementY);

  // console.log(startingY);

  var diff = elementY > 0 ? elementY - startingY : elementY + startingY;

  //console.log(elementY);

  var start;

  window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp;
    var time = timestamp - start;
    // Get percent of completion in range [0, 1].
    var percent = Math.min(time / duration, 1);

    window.scrollTo(0, diff * percent);

    // Proceed with animation as long as we wanted it to.
    if (time < duration) {
      window.requestAnimationFrame(step);
    }
  });
}
export default function doScrolling(id, padding = 0, duration = 700) {
  var startingY = window.pageYOffset;

  var rect = document.getElementById(id);

  var elementY = rect.offsetTop;

  var diff = elementY - startingY - padding;
  var start;

  window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp;
    var time = timestamp - start;
    // Get percent of completion in range [0, 1].
    var percent = Math.min(time / duration, 1);

    window.scrollTo(0, startingY + diff * percent);

    // Proceed with animation as long as we wanted it to.
    if (time < duration) {
      window.requestAnimationFrame(step);
    }
  });
}
